import { useEffect, useState } from 'react';
import { Grid, Box, Dialog, Divider, withStyles, Button, Theme, createStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Userpreferences from './userpreferences'
import { useSelector } from "react-redux";

const styles = (theme: Theme) =>
	createStyles({
		root: {
			margin: 0,
			padding: theme.spacing(2),
			paddingTop: 26
		},
		closeButton: {
			position: 'absolute',
			right: theme.spacing(1),
			background: 'transparent!important'
		},
		header: {
			color: '#212D40',
			fontFamily: 'Spartan-bold',
			fontSize: 24,
			paddingLeft: 17,
			paddingBottom: 7,
			display: 'flex',
			alignItems: 'center'
		}
	});

const ViewUser = ({ open, onClose }: any) => {

	const { user } = useSelector((state: any) => state.adminUser);
	const [state, setState] = useState({
		first_name: "",
		last_name: "",
		username: "",
		active: "",
		preferences: {}
	});

	//set all data when open edit role popup
	useEffect(() => {
		if (user !== undefined && user.preferences !== undefined) {
			setState({
				first_name: user.first_name,
				last_name: user.last_name,
				username: user.username,
				active: user.active,
				preferences: user.preferences
			});
		}
	}, [user]);


	const DialogTitle = withStyles(styles)((props: any) => {
		const { children, classes, onClose, ...other } = props;
		return (
			<MuiDialogTitle disableTypography className={classes.root} {...other}>
				<div className={classes.header}>
					{children}
					{onClose ? (
						<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
							<img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
						</IconButton>
					) : null}
				</div>
			</MuiDialogTitle>
		);
	});
	
	return (

		<div className="card">

			<Grid container>
				<Grid item>
					<Dialog
						
						disableEscapeKeyDown
						fullWidth={true}
						maxWidth={'sm'}
						open={open}
						className="modal-custom"
						scroll="body"
					>
						<div>
							<DialogTitle onClose={onClose}>
								User details
        					</DialogTitle>
							<Divider />

							<Box m={4} pl={1} mt={0} pr={1}>
								<div className="roleview-container">
									<div className="main-box">
										<div className="main-box-header">
											<p>First Name::</p>
										</div>
										<div>
											<p>{state.first_name ? state.first_name : "-"}</p>
										</div>
									</div>
									<div className="main-box">
										<div className="main-box-header">
											<p>Last Name::</p>
										</div>
										<div>
											<p>{state.last_name ? state.last_name : "-"}</p>
										</div>
									</div>
									<div className="main-box">
										<div className="main-box-header">
											<p>Username::</p>
										</div>
										<div>
											<p>{state.username ? state.username : "-"}</p>
										</div>
									</div>
									<div className="main-box">
										<div className="main-box-header">
											<p>Status::</p>
										</div>
										<div>
											<p>{state.active ? "Active" : "Inactive"}</p>
										</div>
									</div>
								</div>
								<Grid container spacing={3} className="role-create">
									{user && user.preferences.map((data: any, index: any) => (
										<>
											<Grid item xs={6}>
												<Grid container spacing={1}>
													<Userpreferences key={index} data={data} dataIndex={index} />

												</Grid>
											</Grid>
										</>
									))}
								</Grid>
							</Box>
							<Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
								<Button onClick={onClose}>
									Cancel
								</Button>&nbsp;&nbsp;&nbsp;
							</Box>
						</div>
					</Dialog>
				</Grid>
			</Grid>
		</div>
	)
}
export default ViewUser;

